
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { UpdateLevelModel } from "@models/level";
@Component
export default class CreateLevelComponent extends Vue {
  currentLevel: UpdateLevelModel = new UpdateLevelModel();
  languages: string[] = [];
  isLoading = false;

  get title(): string {
    return this.id ? "Редактирование уровень" : "Добавление нового уровня";
  }

  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }

  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.currentLevel.initLanguages(this.languages);
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }

  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.LevelService.getLevelAsync(this.id);
    this.currentLevel.fromServerModel(res);
    this.isLoading = false;
  }

  async save() {
    if (!(this.$refs.translationTabs as any).isValid()) return;
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.currentLevel.toServerModel();
    const res = await this.$api.LevelService.updateLevelAsync(request);
    if (res) {
      this.$dialog.success("Уровень успешно обновлен");
      this.$router.back();
    }
    this.isLoading = false;
  }
}
